import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Reaction } from 'features/room-reactions/types';
import { useReactionsManager } from 'features/room-reactions/hooks/useReactionsManager';
import { useRoomReactions } from 'features/room-reactions/useRoomReactions';

export const useRoomReactionsControl = () => {
  const { t } = useTranslation('room');

  const reactionsManager = useReactionsManager();

  const { isFeatureAvailable, isFeatureEnabled, canSendRoomReactions } = useRoomReactions();

  const sendReaction = useCallback(
    (reaction: Reaction) => {
      reactionsManager.sendReaction(reaction);
    },
    [reactionsManager]
  );

  return {
    sendReaction,
    canSendRoomReactions,
    isFeatureEnabled,
    isFeatureAvailable,
    label: t('toolbar.reactions'),
    icon: 'reactions-smile',
  };
};
